import ShipNotificationCard from './ShipNotificationCard'

export default ShipNotificationCard
